import React from 'react';
import '../../../../assets/css/screens/serviceprovider/dashboard/cancel page/CancelPage.css';

export default function CancelPage() {
  const handleRetryClick = (e) => {
    e.preventDefault();
    // Replace with your actual Stripe onboarding / retry route
    window.location.href = '/worker-dashboard';
  };

  return (
    <div className="cancel-page">
      <div className="card">
        <div className="badge-wrap">
          <div className="badge-ring"></div>
          <svg className="cross" viewBox="0 0 96 96">
            <path className="cross-path cross-path-1" d="M36 36 L60 60" />
            <path className="cross-path cross-path-2" d="M60 36 L36 60" />
          </svg>
        </div>

        <h1>Verification not complete</h1>
        <p className="sub">
          We couldn't confirm your verification with <b>Stripe</b>. Your
          WorkHub account isn't active yet, but you can pick up right where
          you left off.
        </p>

        <div className="status-pill">
          <span className="status-dot"></span>
          Verification incomplete
        </div>

        <a href="#" className="btn" onClick={handleRetryClick}>
          Try Again
        </a>
        <p className="footnote">
          Ran into an issue? <a href="#">Contact support</a>
        </p>
      </div>
    </div>
  );
}